<div class="min-h-screen bg-gray-50 text-gray-900 dark:bg-gray-950 dark:text-white">
  <div class="min-w-0">
    <app-header />
    <main class="mx-auto w-full min-w-0 p-4 md:p-6">
      <router-outlet />
    </main>
  </div>
</div>
